import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';

const dollar = Intl.NumberFormat('en-US', {
  style: "currency",
  currency: "USD",
});

const PaymentOptions = ({purchaser, paymentOptions}) => {

  const [paymentOption, setPaymentOption] = useState({});

  useEffect(() => {
    if(Object.keys(purchaser).length > 0){
      setPaymentOption(paymentOptions.find(option => option.id === purchaser.paymentOptionId))
    }
  }, [purchaser, paymentOptions])

  return (
    <Row className='mt-5 justify-content-center'>
      <Col md={5} className="mt-4">
        <div className="icon icon-shape bg-gradient-success shadow-success text-center">
					<i className="ni ni-money-coins text-success" style={{fontSize: '8rem', color: 'green'}}/>
				</div>
               
      </Col>
      <Col md={19}>
      {(!!paymentOption && !(Object.keys(paymentOption).length > 0)) ? null :
        !paymentOption?.requiresAmount ?
          <>
            <p>Selected payment option:</p>
            <h2>{paymentOption?.name}</h2>
          </>

        : paymentOption.id === 2 ?
        <>
          <p>{paymentOption.name}:</p>
          <h2>{dollar.format(purchaser.funds)}</h2>

          <br/>

          <p style={{ fontSize: 'small', display: 'inline' }}>Prepaid Funds:</p>
          <h2 style={{ fontSize: 'small', display: 'inline' }}>{dollar.format(purchaser.prepaidFunds)}</h2>
          {/* <p >Prepaid Funds:</p> <h2 style={{ fontSize: 'medium', display: 'inline' }}>{dollar.format(purchaser.prepaidFunds)}</h2> */}

          <br/>
          
          {
            purchaser?.creditThreshold > 0 ?  
            <> 
            <p style={{ fontSize: 'small', display: 'inline' }}>Credit Threshold:</p>
            <h2 style={{ fontSize: 'small', display: 'inline' }}>{dollar.format(purchaser.creditThreshold)}</h2>
  
            </>
            : ""}
          
          <br/>
          
          {
             purchaser?.creditThreshold > 0 ?  
             <>
              <p style={{ fontSize: 'small', display: 'inline' }}>Credit Funds:</p>
          <h2 style={{ fontSize: 'small', display: 'inline' }}>{dollar.format(purchaser.creditLimit)}</h2>
          </>

          :""}
         
        </>
        : 
        <>
          <p>{paymentOption.name}:</p>
          <h2>{dollar.format(purchaser.creditLimit)}</h2>
        </>
      }
        <Row className='justify-content-center'>
          <Col md={6}>
            
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
 
export default PaymentOptions;